import { ActivitySummary } from "./ActivitySummary";
import { MentalHealthTest } from "./MentalHealthTest";
import { MoodTracker } from "./MoodTracker";

export const HabitChart = ({ data }) => {
  if (!data) {
    return <div>WAITING FOR REPORT DATA...</div>;
  }
  const { mht, moodData, habitData, dateRange, clientName, startDate } = data;
  
  const startDayObject = new Date(startDate);
  const dayOfWeek = startDayObject.getDay();
  const startDayForSummary = dayOfWeek === 0 ? 7 : dayOfWeek;

  return (
    <div className="h-screen w-screen overflow-x-auto bg-[#F6F1E5] print:h-auto print:w-auto print:overflow-visible print:bg-[#F6F1E5]">
      {/* This wrapper provides padding and a max-width for a clean document look on print. */}
      <div className="px-4 md:px-8 py-4 md:py-8 print:py-0 mx-auto max-w-4xl">
        {/* A title makes the printed document more professional. */}
        <h1 className="text-3xl font-bold text-left pb-4 print:pt-8">
          {`${clientName}'s self-care report`}
        </h1>
        <h2 className="text-2xl border-b-2 text-left mb-8">{`${dateRange}`}</h2>

        {/* --- Mood Tracker Section --- */}
        {moodData.length != 0 ? (
          <div className="mb-8 break-inside-avoid">
            <h2 className="text-2xl font-semibold mb-4">Mood Tracker</h2>
            <div className="flex justify-center print:justify-center">
              <MoodTracker Score={moodData} />
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {/* --- Mental Health Tests Section --- */}
        {Object.keys(mht).length !== 0 ? (
          <div className="mb-8">
            <h2 className="text-2xl text-left font-semibold mb-4 break-inside-avoid">
              Track your mental health
            </h2>
            {/* On print, use two columns and center items */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 print:grid-cols-2 print:gap-4 print:place-items-center">
              {Object.entries(mht).map(([testName, scores]) => (
                // KEY CHANGE 3: Each card is wrapped to prevent it from splitting across pages.
                <div key={testName} className="break-inside-avoid print:justify-self-center bg-white rounded-2xl p-4">
                  <MentalHealthTest TestName={testName} Score={scores} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div>
          {habitData.length != 0 ? (
            <>
              <h2 className="text-2xl text-left font-semibold mb-4">
                Self care goals
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 print:grid-cols-2 print:place-items-center">
                {Object.entries(habitData)
                  .filter(([activityName]) => activityName.toLowerCase() !== 'track your mood')
                  .map(([activityName, scores]) => (
                  <div key={activityName} className="break-inside-avoid print:justify-self-center">
                    <ActivitySummary
                      data={scores}
                      ActivityName={activityName}
                      StartDay={startDayForSummary}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
};
